import vn from './vn'
import en from './en'
const messages = {
  vn,
  en
}

export default messages
